(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-countdown"] && !Shopify.designMode) return;
  try {
    if (document.querySelector('.cart-countdown')) {
    class CartCountdown {
      constructor(element) {
        this.element = element;
        this.minutes = parseInt(element.dataset.countdownMinutes) || 15;
        this.timeElement = element.querySelector('.cart-countdown__time');
        this.storageKey = 'cart_countdown_end';
        
        this.init();
      }

      init() {
        // Vérifier s'il y a un compte à rebours en cours
        const savedEndTime = localStorage.getItem(this.storageKey);
        const now = Date.now();

        if (savedEndTime && parseInt(savedEndTime) > now) {
          // Continuer le compte à rebours existant
          this.endTime = parseInt(savedEndTime);
        } else {
          // Démarrer un nouveau compte à rebours
          this.startNewCountdown();
        }

        this.updateDisplay();
        this.startTimer();
      }

      startNewCountdown() {
        this.endTime = Date.now() + (this.minutes * 60 * 1000);
        localStorage.setItem(this.storageKey, this.endTime.toString());
      }

      startTimer() {
        this.timer = setInterval(() => {
          this.updateDisplay();
        }, 1000);
      }

      updateDisplay() {
        const now = Date.now();
        const timeLeft = Math.max(0, this.endTime - now);

        if (timeLeft === 0) {
          this.onCountdownEnd();
          return;
        }

        const minutes = Math.floor(timeLeft / 60000);
        const seconds = Math.floor((timeLeft % 60000) / 1000);

        const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        
        if (this.timeElement) {
          this.timeElement.textContent = formattedTime;
        }

        // Ajouter une classe d'urgence quand il reste moins de 2 minutes
        if (timeLeft < 120000) {
          this.element.classList.add('cart-countdown--urgent');
        } else {
          this.element.classList.remove('cart-countdown--urgent');
        }
      }

      onCountdownEnd() {
        clearInterval(this.timer);
        localStorage.removeItem(this.storageKey);
        
        if (this.timeElement) {
          this.timeElement.textContent = '00:00';
        }
        
        // Ajouter une classe pour indiquer que le temps est écoulé
        this.element.classList.add('cart-countdown--expired');
        
        // Vider le panier automatiquement
        this.clearCart();
      }

      clearCart() {
        // Récupérer tous les items du panier
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => response.json())
          .then(cart => {
            if (cart.items && cart.items.length > 0) {
              // Créer un tableau de promesses pour supprimer tous les items
              const updates = {};
              cart.items.forEach(item => {
                updates[item.id] = 0;
              });

              // Vider le panier en mettant toutes les quantités à 0
              return fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });
            }
          })
          .then(response => {
            if (response) {
              return response.json();
            }
          })
          .then(data => {
            if (data) {
              // Rafraîchir l'affichage du panier
              const cartItemsComponent = document.querySelector('cart-items-component');
              if (cartItemsComponent) {
                const sectionId = cartItemsComponent.dataset.sectionId;
                
                // Récupérer le contenu mis à jour de la section
                fetch(window.location.pathname + '?section_id=' + sectionId)
                  .then(response => response.text())
                  .then(responseText => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = responseText;
                    
                    const newCartItemsComponent = tempDiv.querySelector('cart-items-component');
                    if (newCartItemsComponent) {
                      cartItemsComponent.innerHTML = newCartItemsComponent.innerHTML;
                    }

                    // Déclencher un événement pour informer que le panier a été vidé
                    window.dispatchEvent(new CustomEvent('cart:cleared', {
                      detail: { reason: 'countdown_expired' }
                    }));
                  });
              }

              // Rafraîchir aussi le compteur du panier dans le header
              if (typeof window.refreshCart === 'function') {
                window.refreshCart();
              }
            }
          })
          .catch(error => {
            console.error('Error clearing cart:', error);
          });
      }

      reset() {
        clearInterval(this.timer);
        this.startNewCountdown();
        this.startTimer();
        this.element.classList.remove('cart-countdown--expired', 'cart-countdown--urgent');
      }
    }

    // Initialiser le compte à rebours
    document.addEventListener('DOMContentLoaded', function() {
      const countdownElement = document.querySelector('.cart-countdown');
      if (countdownElement) {
        const countdown = new CartCountdown(countdownElement);

        // Réinitialiser le compte à rebours quand un produit est ajouté au panier
        window.addEventListener('cart:updated', function() {
          countdown.reset();
        });
      }
    });

    // Nettoyer le timer quand la page se décharge
    window.addEventListener('beforeunload', function() {
      const countdownElement = document.querySelector('.cart-countdown');
      if (countdownElement && countdownElement.countdown) {
        clearInterval(countdownElement.countdown.timer);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-crossell"] && !Shopify.designMode) return;
  try {
    // Gestion des événements pour les éléments interactifs du crossell
  // Fonction pour initialiser les event listeners du crossell
  function initializeCrossellListeners(container = document) {
    console.log('Initialisation des listeners crossell sur:', container);
    console.log('Nombre de slideshows trouvés:', container.querySelectorAll('.cart-crossell__slideshow').length);

    const getSectionsContext = () => {
      if (window.ThemeCartSync?.getSectionsContext) {
        return window.ThemeCartSync.getSectionsContext();
      }

      const cartItemsComponent = document.querySelector('cart-items-component');
      const sectionId = cartItemsComponent?.dataset?.sectionId;
      return {
        sectionIds: sectionId ? [sectionId] : [],
        sections: sectionId || '',
        sectionsUrl: window.location.pathname,
      };
    };

    const emitSectionsUpdate = (sections) => {
      if (window.ThemeCartSync?.emitSectionsUpdate) {
        window.ThemeCartSync.emitSectionsUpdate(sections, 'cart-crossell');
        return;
      }

      if (!sections || typeof sections !== 'object') return;
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: null,
            sourceId: 'cart-crossell',
            data: {
              source: 'cart-crossell',
              sections,
            },
          },
        })
      );
    };

    const emitCartUpdated = async () => {
      if (window.ThemeCartSync?.emitCartUpdated) {
        await window.ThemeCartSync.emitCartUpdated();
        return;
      }

      // Fallback path — uses the shared cart cache when available.
      const cart = (typeof window.ThemeCartSync?.getCart === 'function')
        ? await window.ThemeCartSync.getCart({ force: true })
        : await (async () => {
            const cartResponse = await fetch('/cart.js');
            if (!cartResponse.ok) return null;
            return cartResponse.json();
          })();
      if (!cart) return;
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    };

    // Fonction pour gérer les clics sur les éléments interactifs
    function handleInteractiveClick(event) {
      const target = event.target.closest('[data-interactive="true"]');
      if (!target) return;
      
      // Empêcher la propagation vers le slideshow
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      // Si c'est un select de variante, on met à jour le prix
      if (target.tagName === 'SELECT' && target.classList.contains('cart-crossell__variant-select')) {
        const productId = target.dataset.productId;
        const variantId = target.value;
        const productCard = target.closest('.cart-crossell__product');
        const priceElement = productCard.querySelector('.cart-crossell__product-price');
        const addButton = productCard.querySelector('.cart-crossell__add-button');
        
        // Mettre à jour le data-variant-id du bouton d'ajout
        if (addButton) {
          addButton.dataset.variantId = variantId;
        }

        // Récupérer le prix de la nouvelle variante via l'API produit
        fetch(`/products/${productId}?variant=${variantId}`)
          .then(response => response.text())
          .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            
            // Trouver le prix dans la réponse
            const source = html.querySelector('product-price .price') ;
            if (source && priceElement) {
              // Mettre à jour le prix
              priceElement.innerHTML = source.innerHTML;
            }
          })
          .catch((error) => {
            console.error('Error updating variant price:', error);
          });

        return;
      }
      
      // Si c'est un bouton d'ajout au panier
      if (target.tagName === 'BUTTON' && target.classList.contains('cart-crossell__add-button')) {
        event.preventDefault();
        
        // Récupérer l'ID de la variante
        let variantId = target.dataset.variantId;
        
        // Si on a un select de variantes, utiliser la variante sélectionnée
        const variantSelect = target.closest('.cart-crossell__product-actions').querySelector('.cart-crossell__variant-select');
        if (variantSelect) {
          variantId = variantSelect.value;
        }

        // Désactiver le bouton et montrer le chargement
        target.setAttribute('aria-busy', 'true');
        target.disabled = true;

        const sectionsContext = getSectionsContext();
        const payload = {
          items: [{
            id: variantId,
            quantity: 1
          }]
        };
        if (sectionsContext.sections) {
          payload.sections = sectionsContext.sections;
          payload.sections_url = sectionsContext.sectionsUrl;
        }

        // Ajouter au panier via l'API Shopify
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
        .then(response => response.json())
        .then(data => {
          // Réactiver le bouton
          target.setAttribute('aria-busy', 'false');
          target.disabled = false;

          if (data?.sections) {
            emitSectionsUpdate(data.sections);
          }
          emitCartUpdated();

          // Ouvrir le drawer si configuré pour s'ouvrir automatiquement
          const cartDrawer = document.querySelector('cart-drawer-component');
          if (cartDrawer && cartDrawer.hasAttribute('auto-open')) {
            cartDrawer.open();
          }

          // Rafraîchir aussi le mini-panier si la fonction existe
          if (typeof window.refreshCart === 'function') {
            window.refreshCart();
          }
        })
        .catch(error => {
          console.error('Error:', error);
          // Réactiver le bouton en cas d'erreur
          target.setAttribute('aria-busy', 'false');
          target.disabled = false;
        });
      }
    }
    
    // Ajouter les listeners sur tous les slideshows de crossell
    const crossellSlideshows = container.querySelectorAll('.cart-crossell__slideshow');
    
    crossellSlideshows.forEach(slideshow => {
      // Nettoyer les anciens event listeners si nécessaire
      const oldClone = slideshow.cloneNode(true);
      slideshow.parentNode.replaceChild(oldClone, slideshow);
      const newSlideshow = oldClone;
      
      // Gérer les événements mousedown pour empêcher le slideshow de capturer
      newSlideshow.addEventListener('mousedown', function(event) {
        const target = event.target.closest('[data-interactive="true"]');
        if (target) {
          event.stopPropagation();
          event.stopImmediatePropagation();
        }
      }, true); // Utiliser capture pour intercepter avant le slideshow
      
      // Gérer les clics
      newSlideshow.addEventListener('click', handleInteractiveClick, true);
      
      // Gérer les événements touchstart pour mobile
      newSlideshow.addEventListener('touchstart', function(event) {
        const target = event.target.closest('[data-interactive="true"]');
        if (target) {
          event.stopPropagation();
          event.stopImmediatePropagation();
        }
      }, true);
    });
  }

   // Fonction pour gérer l'affichage des contrôles de navigation
   function updateNavigationControls(container = document) {
     const slideshows = container.querySelectorAll('.cart-crossell__slideshow');
     
     slideshows.forEach(slideshow => {
       const slides = slideshow.querySelectorAll('slideshow-slide');
       const arrows = slideshow.querySelectorAll('slideshow-arrow');
       const dots = slideshow.querySelector('slideshow-dots');
       
       // Masquer les contrôles s'il n'y a qu'un seul slide
       if (slides.length <= 1) {
         slideshow.setAttribute('data-single-slide', 'true');
         arrows.forEach(arrow => arrow.style.display = 'none');
         if (dots) dots.style.display = 'none';
       } else {
         slideshow.removeAttribute('data-single-slide');
         arrows.forEach(arrow => arrow.style.display = 'flex');
         if (dots) dots.style.display = 'flex';
       }
     });
   }

   // Initialiser les listeners au chargement de la page et à l'ouverture du drawer
   document.addEventListener('DOMContentLoaded', function() {
     console.log('DOMContentLoaded - Initialisation des listeners');
     initializeCrossellListeners();
     updateNavigationControls();
     
     // Écouter l'ouverture du drawer
     const cartDrawer = document.querySelector('cart-drawer-component');
     if (cartDrawer) {
       const dialog = cartDrawer.querySelector('dialog');
       if (dialog) {
         const observer = new MutationObserver((mutations) => {
           mutations.forEach((mutation) => {
             if (mutation.attributeName === 'open' && dialog.hasAttribute('open')) {
               console.log('Drawer ouvert - Réinitialisation des listeners');
               initializeCrossellListeners(dialog);
               updateNavigationControls(dialog);
             }
           });
         });
         
         observer.observe(dialog, { attributes: true });
       }
     }
   });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-empty-collection"] && !Shopify.designMode) return;
  try {
    // Fonction pour gérer l'affichage des contrôles de navigation
  function updateEmptyCollectionNavigationControls() {
    const slideshows = document.querySelectorAll('.cart-empty-collection__slideshow');
    
    slideshows.forEach(slideshow => {
      const slides = slideshow.querySelectorAll('slideshow-slide');
      const arrows = slideshow.querySelectorAll('slideshow-arrow');
      const dots = slideshow.querySelector('slideshow-dots');
      
      // Masquer les contrôles s'il n'y a qu'un seul slide
      if (slides.length <= 1) {
        slideshow.setAttribute('data-single-slide', 'true');
        arrows.forEach(arrow => arrow.style.display = 'none');
        if (dots) dots.style.display = 'none';
      } else {
        slideshow.removeAttribute('data-single-slide');
        arrows.forEach(arrow => arrow.style.display = 'flex');
        if (dots) dots.style.display = 'flex';
      }
    });
  }

  // Initialiser au chargement et à l'ouverture du drawer
  document.addEventListener('DOMContentLoaded', function() {
    updateEmptyCollectionNavigationControls();
    
    // Écouter l'ouverture du drawer
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer) {
      const dialog = cartDrawer.querySelector('dialog');
      if (dialog) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'open' && dialog.hasAttribute('open')) {
              setTimeout(() => {
                updateEmptyCollectionNavigationControls();
              }, 100);
            }
          });
        });
        
        observer.observe(dialog, { attributes: true });
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-gifts"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__cartGiftsV2Attached) return;
    window.__cartGiftsV2Attached = true;

    const getDrawer = () => document.querySelector('cart-items-component');
    const getContainer = () => document.querySelector('.cart-gifts');

    const getSectionId = () => getDrawer()?.dataset?.sectionId;
    const parseIdSet = (value) => {
      return new Set(
        (value || '')
          .split(',')
          .map((entry) => entry.trim())
          .filter((entry) => entry !== '')
      );
    };
    const toBoolean = (value) => String(value).toLowerCase() === 'true';
    const getRules = () => {
      const container = getContainer();
      if (!container) return null;
      return {
        tier1DiscountCodesRaw: (container.dataset.tier1DiscountCodes || '').trim(),
        tier2DiscountCodesRaw: (container.dataset.tier2DiscountCodes || '').trim(),
        tier1FreeWithoutCode: toBoolean(container.dataset.tier1FreeWithoutCode),
        tier2FreeWithoutCode: toBoolean(container.dataset.tier2FreeWithoutCode),
        tier1Threshold: Number(container.dataset.tier1Threshold || 0),
        tier1EveryOrder: toBoolean(container.dataset.tier1EveryOrder),
        tier2Threshold: Number(container.dataset.tier2Threshold || 0),
        tier1AllowedVariants: parseIdSet(container.dataset.tier1AllowedVariantIds),
        tier2AllowedVariants: parseIdSet(container.dataset.tier2AllowedVariantIds),
      };
    };
    const fetchCart = async () => {
      if (typeof window.ThemeCartSync?.getCart === 'function') {
        return window.ThemeCartSync.getCart();
      }
      const response = await fetch('/cart.js');
      return response.json();
    };
    const fetchJsonWithRetry = async (url, options = {}, config = {}) => {
      const { timeoutMs = 12000, retries = 1 } = config;
      let lastError = null;

      for (let attempt = 0; attempt <= retries; attempt += 1) {
        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);

        try {
          const response = await fetch(url, { ...options, signal: controller.signal });
          if (!response.ok) {
            throw new Error(`${url} failed (${response.status})`);
          }
          const data = await response.json();
          return data;
        } catch (error) {
          lastError = error;
          const aborted = error?.name === 'AbortError';
          const isLastAttempt = attempt >= retries;
          if (isLastAttempt) break;
          // Small backoff before retrying transient failures.
          const retryDelay = aborted ? 200 : 120;
          await new Promise((resolve) => window.setTimeout(resolve, retryDelay));
        } finally {
          window.clearTimeout(timeoutId);
        }
      }

      throw lastError || new Error(`${url} request failed`);
    };
    const getNonGiftTotal = (cart) => {
      return cart.items.reduce((sum, item) => {
        const isGift = item?.properties?._is_gift === 'true';
        return isGift ? sum : sum + item.final_line_price;
      }, 0);
    };
    const getSectionsContext = () => {
      if (window.ThemeCartSync?.getSectionsContext) {
        return window.ThemeCartSync.getSectionsContext();
      }

      const sectionId = getSectionId();
      return {
        sectionIds: sectionId ? [sectionId] : [],
        sections: sectionId || '',
        sectionsUrl: window.location.pathname,
      };
    };

    const emitSectionsUpdate = (sections, source = 'cart-gifts') => {
      if (window.ThemeCartSync?.emitSectionsUpdate) {
        window.ThemeCartSync.emitSectionsUpdate(sections, source);
        return;
      }

      if (!sections || typeof sections !== 'object') return;
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: null,
            sourceId: 'cart-gifts',
            data: {
              source,
              sections,
            },
          },
        })
      );
    };

    const emitCartUpdated = async (cartPayload) => {
      if (window.ThemeCartSync?.emitCartUpdated) {
        await window.ThemeCartSync.emitCartUpdated(cartPayload);
        return;
      }

      const cart = Array.isArray(cartPayload?.items) ? cartPayload : await fetchCart();
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    };
    const getCartFromResponse = (data) => {
      return Array.isArray(data?.items) ? data : null;
    };
    const setGiftActionsLoading = (isLoading) => {
      const actions = document.querySelectorAll('[data-gift-choose], [data-gift-change]');
      actions.forEach((action) => {
        action.disabled = isLoading;
        action.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      });
    };

    const removeGiftById = async (lineKeyOrId) => {
      if (!lineKeyOrId) return;
      const sectionsContext = getSectionsContext();
      const payload = {
        id: String(lineKeyOrId),
        quantity: 0,
      };
      if (sectionsContext.sections) {
        payload.sections = sectionsContext.sections;
        payload.sections_url = sectionsContext.sectionsUrl;
      }

      return fetchJsonWithRetry(
        '/cart/change.js',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        },
        { timeoutMs: 12000, retries: 1 }
      );
    };

    const addGift = async (variantId, tier) => {
      const sectionsContext = getSectionsContext();
      const payload = {
        items: [
          {
            id: String(variantId),
            quantity: 1,
            properties: {
              _is_gift: 'true',
              _gift_tier: String(tier),
            },
          },
        ],
      };
      if (sectionsContext.sections) {
        payload.sections = sectionsContext.sections;
        payload.sections_url = sectionsContext.sectionsUrl;
      }

      return fetchJsonWithRetry(
        '/cart/add.js',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        },
        { timeoutMs: 12000, retries: 1 }
      );
    };

    const getExistingDiscountCodes = () => {
      return Array.from(document.querySelectorAll('.cart-discount__pill'))
        .map((pill) => pill?.dataset?.discountCode || '')
        .map((code) => code.trim())
        .filter((code) => code !== '');
    };

    const parseCodesList = (value) => {
      return Array.from(
        new Set(
          String(value || '')
            .split(',')
            .map((entry) => entry.trim())
            .filter((entry) => entry !== '')
        )
      );
    };

    const applyGiftDiscountCode = async (tier) => {
      const rules = getRules();
      if (!rules) return;
      const tierFreeWithoutCode = tier === '1' ? rules.tier1FreeWithoutCode : rules.tier2FreeWithoutCode;
      if (tierFreeWithoutCode) return;

      const targetCodes =
        tier === '1' ? parseCodesList(rules.tier1DiscountCodesRaw) : parseCodesList(rules.tier2DiscountCodesRaw);
      if (!targetCodes.length) return;

      const existingCodes = getExistingDiscountCodes();
      const existingCodesUpper = existingCodes.map((code) => code.toUpperCase());
      const sectionsContext = getSectionsContext();
      const cartUpdateUrl =
        (typeof Theme !== 'undefined' && Theme.routes?.cart_update_url) || '/cart/update.js';
      const targetCodesUpper = targetCodes.map((code) => code.toUpperCase());
      const alreadyApplied = targetCodesUpper.every((code) => existingCodesUpper.includes(code));
      if (alreadyApplied) return null;

      const runUpdate = async (codes) => {
        const body = {
          discount: codes.join(','),
        };

        if (sectionsContext.sections) {
          body.sections = sectionsContext.sections;
          body.sections_url = sectionsContext.sectionsUrl;
        }

        const data = await fetchJsonWithRetry(
          cartUpdateUrl,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          },
          { timeoutMs: 12000, retries: 1 }
        );
        const discountCodes = Array.isArray(data?.discount_codes) ? data.discount_codes : [];
        const applicableCodesUpper = discountCodes
          .filter((discount) => discount && discount.applicable === true)
          .map((discount) => String(discount.code || '').toUpperCase());
        const allTargetsApplied = targetCodesUpper.every((code) => applicableCodesUpper.includes(code));

        return {
          applied: allTargetsApplied,
          data,
        };
      };

      // Always preserve existing customer-applied discount codes (e.g. an
      // active promo like "2 CBD = 1 free"). If the gift code cannot be
      // applied alongside them — typically because Shopify's stacking
      // rules forbid combining the two — we keep the customer's codes
      // and emit a warning. The gift remains in the cart but its line
      // price won't be discounted at checkout; the merchant should
      // configure the gift discount to combine with other discounts.
      const mergedCodes = Array.from(new Set([...existingCodes, ...targetCodes]));
      const mergedAttempt = await runUpdate(mergedCodes);
      if (mergedAttempt.applied) return mergedAttempt.data;

      console.warn(
        `[cart-gifts] Gift discount "${targetCodes.join(', ')}" not applicable ` +
          `alongside existing codes [${existingCodes.join(', ')}]. Existing codes preserved.`
      );
      return mergedAttempt.data;
    };
    const removeTierGiftDiscountCodes = async (tier) => {
      const rules = getRules();
      if (!rules) return null;

      const targetCodes =
        tier === '1' ? parseCodesList(rules.tier1DiscountCodesRaw) : parseCodesList(rules.tier2DiscountCodesRaw);
      if (!targetCodes.length) return null;

      const existingCodes = getExistingDiscountCodes();
      if (!existingCodes.length) return null;

      const targetCodesUpper = new Set(targetCodes.map((code) => code.toUpperCase()));
      const remainingCodes = existingCodes.filter((code) => !targetCodesUpper.has(code.toUpperCase()));
      if (remainingCodes.length === existingCodes.length) return null;

      const sectionsContext = getSectionsContext();
      const cartUpdateUrl =
        (typeof Theme !== 'undefined' && Theme.routes?.cart_update_url) || '/cart/update.js';
      const body = {
        discount: remainingCodes.join(','),
      };

      if (sectionsContext.sections) {
        body.sections = sectionsContext.sections;
        body.sections_url = sectionsContext.sectionsUrl;
      }

      return fetchJsonWithRetry(
        cartUpdateUrl,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        },
        { timeoutMs: 12000, retries: 1 }
      );
    };

    const getCurrentGiftId = (container, tier) => {
      const selectedRow = container.querySelector(`[data-current-tier="${tier}"]`);
      return selectedRow?.dataset?.key || selectedRow?.dataset?.line || null;
    };

    const normalizeCartGifts = async () => {
      if (window.__cartGiftsV2ActionInFlight || window.__cartGiftsV2Normalizing) return;

      const rules = getRules();
      if (!rules) return;

      window.__cartGiftsV2Normalizing = true;

      try {
        const cart = await fetchCart();
        const nonGiftTotal = getNonGiftTotal(cart);
        const tier1Unlocked = rules.tier1EveryOrder
          ? nonGiftTotal > 0
          : rules.tier1Threshold > 0 && nonGiftTotal >= rules.tier1Threshold;
        const tier2Unlocked = rules.tier2Threshold > 0 && nonGiftTotal >= rules.tier2Threshold;
        const seenTiers = new Set();
        const lineIdsToRemove = [];

        cart.items.forEach((item) => {
          const isGift = item?.properties?._is_gift === 'true';
          if (!isGift) return;

          const tier = String(item?.properties?._gift_tier || '');
          const isTier1 = tier === '1';
          const isTier2 = tier === '2';
          const variantId = String(item.variant_id);
          const allowedSet = isTier1 ? rules.tier1AllowedVariants : rules.tier2AllowedVariants;
          const tierUnlocked = isTier1 ? tier1Unlocked : isTier2 ? tier2Unlocked : false;

          const isValidTier = isTier1 || isTier2;
          const isAllowedVariant = isValidTier && allowedSet.has(variantId);
          const hasDuplicateTier = seenTiers.has(tier);

          if (!isValidTier || !tierUnlocked || !isAllowedVariant || hasDuplicateTier) {
            lineIdsToRemove.push(item.key);
            return;
          }

          seenTiers.add(tier);
        });

        if (!lineIdsToRemove.length) return;

        let latestSections = null;
        let latestCartPayload = null;
        for (const lineId of lineIdsToRemove) {
          const mutationData = await removeGiftById(lineId);
          if (mutationData?.sections) {
            latestSections = mutationData.sections;
          }
          latestCartPayload = getCartFromResponse(mutationData) || latestCartPayload;
        }
        if (latestSections) {
          emitSectionsUpdate(latestSections, 'cart-gifts-normalize');
        }
        await emitCartUpdated(latestCartPayload);
      } catch (error) {
        console.error('Gift normalization error:', error);
      } finally {
        window.__cartGiftsV2Normalizing = false;
      }
    };
    const scheduleNormalize = () => {
      window.clearTimeout(window.__cartGiftsV2NormalizeTimeout);
      window.__cartGiftsV2NormalizeTimeout = window.setTimeout(() => {
        normalizeCartGifts();
      }, 180);
    };
    const runGiftAction = async (action) => {
      const previousQueue = window.__cartGiftsV2ActionQueue || Promise.resolve();
      const queuedAction = previousQueue
        .catch(() => {})
        .then(async () => {
          window.__cartGiftsV2ActionInFlight = true;
          setGiftActionsLoading(true);
          try {
            await action();
          } finally {
            window.__cartGiftsV2ActionInFlight = false;
            setGiftActionsLoading(false);
          }
        });

      window.__cartGiftsV2ActionQueue = queuedAction;
      return queuedAction;
    };
    // Snap-point cache. Computing snap points reads layout for every card
    // (forced reflow). The result only changes when card count or slider
    // width changes, so we cache per-slider with a signature.
    const snapPointsCache = new WeakMap();
    const buildSliderSignature = (slider, cards) =>
      `${cards.length}|${slider.clientWidth}|${slider.scrollWidth}`;

    const computeSnapPoints = (slider, cards) => {
      const sliderRect = slider.getBoundingClientRect();
      const maxScrollLeft = Math.max(0, slider.scrollWidth - slider.clientWidth);
      const snapPoints = cards.map((card) => {
        const cardRect = card.getBoundingClientRect();
        const cardLeft = cardRect.left - sliderRect.left + slider.scrollLeft;
        const cardCenter = cardLeft + cardRect.width / 2;
        const centeredTarget = cardCenter - slider.clientWidth / 2;
        return Math.min(maxScrollLeft, Math.max(0, Math.round(centeredTarget)));
      });
      return Array.from(new Set(snapPoints)).sort((a, b) => a - b);
    };

    const getSliderSnapPoints = (slider) => {
      if (!(slider instanceof HTMLElement)) return [];
      const cards = Array.from(slider.querySelectorAll('.cart-gifts__card'));
      if (!cards.length) return [];

      const signature = buildSliderSignature(slider, cards);
      const cached = snapPointsCache.get(slider);
      if (cached && cached.signature === signature) return cached.points;

      const points = computeSnapPoints(slider, cards);
      snapPointsCache.set(slider, { signature, points });
      return points;
    };
    const getNextSnapTarget = (slider, direction) => {
      const snapPoints = getSliderSnapPoints(slider);
      if (!snapPoints.length) return null;

      const current = slider.scrollLeft;
      const epsilon = 3;
      if (direction < 0) {
        for (let index = snapPoints.length - 1; index >= 0; index -= 1) {
          if (snapPoints[index] < current - epsilon) return snapPoints[index];
        }
        return snapPoints[0];
      }

      for (let index = 0; index < snapPoints.length; index += 1) {
        if (snapPoints[index] > current + epsilon) return snapPoints[index];
      }
      return snapPoints[snapPoints.length - 1];
    };
    const updateTierNavState = (tierElement) => {
      if (!(tierElement instanceof HTMLElement)) return;
      const slider = tierElement.querySelector('.cart-gifts__slider');
      if (!(slider instanceof HTMLElement)) return;

      const prevButton = tierElement.querySelector('[data-gift-nav="prev"]');
      const nextButton = tierElement.querySelector('[data-gift-nav="next"]');
      if (!(prevButton instanceof HTMLButtonElement) || !(nextButton instanceof HTMLButtonElement)) return;

      const maxScrollLeft = Math.max(0, slider.scrollWidth - slider.clientWidth);
      const atStart = slider.scrollLeft <= 1;
      const atEnd = slider.scrollLeft >= maxScrollLeft - 1;
      const noOverflow = maxScrollLeft <= 1;

      prevButton.disabled = noOverflow || atStart;
      nextButton.disabled = noOverflow || atEnd;
      prevButton.setAttribute('aria-disabled', prevButton.disabled ? 'true' : 'false');
      nextButton.setAttribute('aria-disabled', nextButton.disabled ? 'true' : 'false');
    };
    const updateAllTierNavStates = () => {
      document.querySelectorAll('.cart-gifts__tier').forEach((tierElement) => {
        updateTierNavState(tierElement);
      });
    };
    const scheduleNavStateRefresh = (delay = 60) => {
      window.clearTimeout(window.__cartGiftsV2NavRefreshTimeout);
      window.__cartGiftsV2NavRefreshTimeout = window.setTimeout(() => {
        updateAllTierNavStates();
      }, delay);
    };

    document.addEventListener('click', (event) => {
      const navButton = event.target.closest('[data-gift-nav]');
      if (!navButton) return;

      event.preventDefault();
      const tier = navButton.closest('.cart-gifts__tier');
      const slider = tier?.querySelector('.cart-gifts__slider');
      if (!(slider instanceof HTMLElement)) return;
      updateTierNavState(tier);
      if (navButton instanceof HTMLButtonElement && navButton.disabled) return;

      const direction = navButton.dataset.giftNav === 'prev' ? -1 : 1;
      const targetLeft = getNextSnapTarget(slider, direction);
      if (targetLeft === null) return;
      slider.scrollTo({ left: targetLeft, behavior: 'smooth' });
      window.setTimeout(() => {
        updateTierNavState(tier);
      }, 220);
    });
    document.addEventListener(
      'scroll',
      (event) => {
        const target = event.target;
        if (!(target instanceof HTMLElement) || !target.classList.contains('cart-gifts__slider')) return;
        const tier = target.closest('.cart-gifts__tier');
        updateTierNavState(tier);
      },
      true
    );
    document.addEventListener(
      'load',
      (event) => {
        const target = event.target;
        if (!(target instanceof HTMLImageElement)) return;
        if (!target.closest('.cart-gifts__slider')) return;
        scheduleNavStateRefresh();
      },
      true
    );
    window.addEventListener('resize', () => {
      scheduleNavStateRefresh();
    });
    window.addEventListener('load', () => {
      scheduleNavStateRefresh(260);
    });

    document.addEventListener('click', async (event) => {
      const chooseButton = event.target.closest('[data-gift-choose]');
      const changeButton = event.target.closest('[data-gift-change]');
      if (!chooseButton && !changeButton) return;
      const clickedBusyAction = event.target.closest('[aria-busy="true"]');
      if (clickedBusyAction) return;

      const container = event.target.closest('.cart-gifts');
      if (!container) return;

      if (chooseButton) {
        event.preventDefault();
        const tier = chooseButton.dataset.tier;
        const variantId = chooseButton.dataset.variantId;
        if (!tier || !variantId) return;
        const requiresDiscountCode =
          typeof chooseButton.dataset.giftRequiresCode === 'undefined'
            ? true
            : toBoolean(chooseButton.dataset.giftRequiresCode);

        const rules = getRules();
        if (!rules) return;

        const selectedVariantId = String(variantId);
        const isTier1 = tier === '1';
        const isTier2 = tier === '2';
        const allowedSet = isTier1 ? rules.tier1AllowedVariants : rules.tier2AllowedVariants;
        if (!(isTier1 || isTier2) || !allowedSet.has(selectedVariantId)) return;

        const existingGiftId = getCurrentGiftId(container, tier);
        await runGiftAction(async () => {
          try {
            let latestSections = null;
            let latestCartPayload = null;
            if (existingGiftId) {
              const removeData = await removeGiftById(existingGiftId);
              if (removeData?.sections) {
                latestSections = removeData.sections;
              }
              latestCartPayload = getCartFromResponse(removeData);
            }
            const addData = await addGift(selectedVariantId, tier);
            if (addData?.sections) {
              latestSections = addData.sections;
            }
            latestCartPayload = getCartFromResponse(addData) || latestCartPayload;

            // Never block UI/cart refresh if discount application fails.
            try {
              const discountData = requiresDiscountCode
                ? await applyGiftDiscountCode(tier)
                : await removeTierGiftDiscountCodes(tier);
              if (discountData?.sections) {
                latestSections = discountData.sections;
              }
              latestCartPayload = getCartFromResponse(discountData) || latestCartPayload;
            } catch (discountError) {
              console.warn('Gift discount apply skipped/failed:', discountError);
            }
            if (latestSections) {
              emitSectionsUpdate(latestSections, 'cart-gifts-choose');
            }
            await emitCartUpdated(latestCartPayload);
            scheduleNormalize();
          } catch (error) {
            console.error('Gift choose error:', error);
          }
        });
      }

      if (changeButton) {
        event.preventDefault();
        const giftId = changeButton.dataset.key || changeButton.dataset.line;
        if (!giftId) return;
        await runGiftAction(async () => {
          try {
            const removeData = await removeGiftById(giftId);
            if (removeData?.sections) {
              emitSectionsUpdate(removeData.sections, 'cart-gifts-change');
            }
            await emitCartUpdated(getCartFromResponse(removeData));
            scheduleNormalize();
          } catch (error) {
            console.error('Gift change error:', error);
          }
        });
      }
    });

    // Why 220ms: the cart drawer section re-renders asynchronously after a
    // cart event. Reading layout immediately operates on the stale DOM that
    // is about to be replaced, so we wait for the new DOM to settle.
    document.addEventListener('cart:update', () => {
      scheduleNormalize();
      scheduleNavStateRefresh(220);
    });

    window.addEventListener('cart:updated', (event) => {
      if (Array.isArray(event?.detail?.cart?.items)) {
        window.__cartGiftsV2LatestCart = event.detail.cart;
      }
      scheduleNormalize();
      scheduleNavStateRefresh(220);
    });

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          scheduleNormalize();
          scheduleNavStateRefresh(220);
        },
        { once: true }
      );
    } else {
      scheduleNormalize();
      scheduleNavStateRefresh(220);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Initialize after DOM is fully loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      this.productForm = document.querySelector('product-form-component');
      this.mainAddToCartButton = document.querySelector('[data-type="add-to-cart-form"] [type="submit"]');
      this.variantSelect = this.querySelector('.sticky-add-to-cart__variant-select');
      this.addToCartButton = this.querySelector('.sticky-add-to-cart__button');

      // Bind methods
      this.handleScroll = this.handleScroll.bind(this);
      this.checkVisibility = this.checkVisibility.bind(this);

       // Add event listeners
       window.addEventListener('scroll', this.handleScroll, { passive: true });
       window.addEventListener('resize', this.checkVisibility, { passive: true });
       
       // Prevent clicks on the sticky bar itself
       this.addEventListener('click', (event) => {
         if (!event.target.closest('[data-sticky-add-to-cart]') && !event.target.closest('.sticky-add-to-cart__variant-select')) {
           event.preventDefault();
           event.stopPropagation();
         }
       });

       if (this.variantSelect) {
         this.variantSelect.addEventListener('change', this.handleVariantChange.bind(this));
       }

       if (this.addToCartButton) {
         this.addToCartButton.addEventListener('click', this.handleStickyAddToCart.bind(this));
       }

      if (this.productForm) {
        this.productForm.addEventListener('variant:change', this.handleMainFormVariantChange.bind(this));
      }

      // Listen for variant picker changes
      this.setupVariantPickerListener();

      // Initial visibility check
      this.checkVisibility();

      // Create Intersection Observer for the main add to cart button
      this.setupIntersectionObserver();
    }

    setupIntersectionObserver() {
      if (!this.mainAddToCartButton) return;

      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          this.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, options);

      observer.observe(this.mainAddToCartButton);
    }

    setupVariantPickerListener() {
      // Listen for variant picker events on the document
      document.addEventListener('variant:selected', this.handleVariantPickerChange.bind(this));
      document.addEventListener('variant:update', this.handleVariantPickerChange.bind(this));
    }

    async handleVariantPickerChange(event) {
      console.log('Variant picker change event:', event.type, event.detail);
      
      if (!this.variantSelect || !event.detail) {
        console.warn('Missing variant select or event detail');
        return;
      }

      // Handle both VariantSelectedEvent and VariantUpdateEvent
      const variantId = event.detail.resource?.id || event.detail.id;
      if (!variantId) {
        console.warn('No variant ID found in event');
        return;
      }

      console.log('Updating sticky ATC for variant:', variantId);

      // Update the sticky select to match the variant picker selection
      this.variantSelect.value = variantId;

      // For VariantUpdateEvent, try to use the HTML data first
      if (event.type === 'variant:update' && event.detail.data?.html) {
        console.log('Using HTML data from VariantUpdateEvent');
        // Add a small delay to ensure DOM is updated
        setTimeout(() => {
          this.updatePricesFromHTML(event.detail.data.html);
        }, 50);
        return;
      }

      // Fallback to AJAX for VariantSelectedEvent or if no HTML data
      console.log('Fetching price data via AJAX');
      try {
        // Get current product handle from URL
        const pathParts = window.location.pathname.split('/');
        const productHandle = pathParts[pathParts.length - 1];
        
        // Fetch variant page HTML
        const response = await fetch(`/products/${productHandle}?variant=${variantId}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const html = await response.text();
        
        // Create a temporary container to parse HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        this.updatePricesFromHTML(doc);
      } catch (error) {
        console.error('Error updating sticky button prices from variant picker:', error);
        
        // Last resort: try to update prices from the main page elements
        this.updatePricesFromMainPage();
      }
    }

    updatePricesFromMainPage() {
      console.log('Attempting to update prices from main page elements');
      
      // Try to find price elements on the main page
      const mainPageNewPrice = document.querySelector('.product-form .product-card__button-price--new')?.innerHTML;
      const mainPageComparePrice = document.querySelector('.product-form .price-item-collection_atc')?.innerHTML;
      
      if (mainPageNewPrice || mainPageComparePrice) {
        const newPriceElement = this.querySelector('.product-card__button-price--new');
        const comparePriceElement = this.querySelector('.price-item-collection_atc');
        
        if (newPriceElement && mainPageNewPrice) {
          newPriceElement.innerHTML = mainPageNewPrice;
          console.log('Updated new price from main page:', mainPageNewPrice);
        }
        
        if (comparePriceElement) {
          if (mainPageComparePrice) {
            comparePriceElement.innerHTML = mainPageComparePrice;
            const regularPriceContainer = comparePriceElement.closest('.price-item--regular');
            if (regularPriceContainer) {
              regularPriceContainer.style.display = '';
            }
            console.log('Updated compare price from main page:', mainPageComparePrice);
          } else {
            const regularPriceContainer = comparePriceElement.closest('.price-item--regular');
            if (regularPriceContainer) {
              regularPriceContainer.style.display = 'none';
            }
            console.log('Hid compare price from main page');
          }
        }
      } else {
        console.warn('Could not find price elements on main page');
      }
    }

    updatePricesFromHTML(html, retryCount = 0) {
      console.log('Updating prices from HTML:', html, 'retry:', retryCount);
      
      // Try multiple selectors to find price elements
      const priceSelectors = [
        '.prices-items-collection .product-card__button-price--new',
        '.product-card__button-price--new',
        '.sticky-add-to-cart__button .product-card__button-price--new',
        '[class*="price"][class*="new"]',
        '.add-to-cart-text .product-card__button-price--new'
      ];
      
      const comparePriceSelectors = [
        '.prices-items-collection .price-item-collection_atc',
        '.price-item-collection_atc',
        '.sticky-add-to-cart__button .price-item-collection_atc',
        '[class*="price"][class*="compare"]',
        '.add-to-cart-text .price-item-collection_atc'
      ];
      
      // Find new price
      let newPrice = null;
      for (const selector of priceSelectors) {
        const element = html.querySelector(selector);
        if (element && element.innerHTML && element.innerHTML.trim()) {
          newPrice = element.innerHTML;
          console.log('Found new price with selector:', selector, newPrice);
          break;
        }
      }
      
      // Find compare price
      let comparePrice = null;
      for (const selector of comparePriceSelectors) {
        const element = html.querySelector(selector);
        if (element && element.innerHTML && element.innerHTML.trim()) {
          comparePrice = element.innerHTML;
          console.log('Found compare price with selector:', selector, comparePrice);
          break;
        }
      }
      
      // Update sticky button prices
      const newPriceElement = this.querySelector('.product-card__button-price--new');
      const comparePriceElement = this.querySelector('.price-item-collection_atc');
      
      console.log('Sticky elements found:', {
        newPriceElement: !!newPriceElement,
        comparePriceElement: !!comparePriceElement,
        newPrice: newPrice,
        comparePrice: comparePrice
      });
      
      let priceUpdated = false;
      
      if (newPriceElement && newPrice) {
        newPriceElement.innerHTML = newPrice;
        priceUpdated = true;
        console.log('Updated new price to:', newPrice);
      } else if (newPriceElement) {
        console.warn('New price element found but no price data');
      } else {
        console.warn('New price element not found in sticky ATC');
      }
      
      if (comparePriceElement) {
        if (comparePrice) {
          comparePriceElement.innerHTML = comparePrice;
          const regularPriceContainer = comparePriceElement.closest('.price-item--regular');
          if (regularPriceContainer) {
            regularPriceContainer.style.display = '';
          }
          priceUpdated = true;
          console.log('Updated compare price to:', comparePrice);
        } else {
          const regularPriceContainer = comparePriceElement.closest('.price-item--regular');
          if (regularPriceContainer) {
            regularPriceContainer.style.display = 'none';
          }
          console.log('Hid compare price');
        }
      } else {
        console.warn('Compare price element not found in sticky ATC');
      }
      
      // If no prices were updated and we haven't retried yet, try again after a delay
      if (!priceUpdated && retryCount < 2) {
        console.log('No prices updated, retrying in 100ms...');
        setTimeout(() => {
          this.updatePricesFromHTML(html, retryCount + 1);
        }, 100);
      } else if (!priceUpdated) {
        console.warn('Failed to update prices after retries, trying main page fallback');
        this.updatePricesFromMainPage();
      }
    }

    handleScroll() {
      requestAnimationFrame(this.checkVisibility);
    }

    checkVisibility() {
      if (!this.mainAddToCartButton) return;

      const buttonRect = this.mainAddToCartButton.getBoundingClientRect();
      const isButtonVisible = buttonRect.top < window.innerHeight && buttonRect.bottom > 0;
      
      this.classList.toggle('is-visible', !isButtonVisible);
    }

     async handleVariantChange(event) {
       const variantId = event.target.value;
       
       // Update main form
       if (this.productForm) {
         const mainFormVariantInput = this.productForm.querySelector('input[name="id"]');
         if (mainFormVariantInput) {
           mainFormVariantInput.value = variantId;
           mainFormVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
         }
       }

       // Update sticky button prices via AJAX
       try {
         // Get current product handle from URL
         const pathParts = window.location.pathname.split('/');
         const productHandle = pathParts[pathParts.length - 1];
         
         // Fetch variant page HTML
         const response = await fetch(`/products/${productHandle}?variant=${variantId}`);
         const html = await response.text();
         
         // Create a temporary container to parse HTML
         const parser = new DOMParser();
         const doc = parser.parseFromString(html, 'text/html');
         
         // Get price elements from the fetched HTML
         const newPrice = doc.querySelector('.prices-items-collection .product-card__button-price--new')?.innerHTML;
         const comparePrice = doc.querySelector('.prices-items-collection .price-item-collection_atc')?.innerHTML;
         
         // Update sticky button prices
         const newPriceElement = this.querySelector('.product-card__button-price--new');
         const comparePriceElement = this.querySelector('.price-item-collection_atc');
         
         if (newPriceElement && newPrice) {
           newPriceElement.innerHTML = newPrice;
         }
         
         if (comparePriceElement) {
           if (comparePrice) {
             comparePriceElement.innerHTML = comparePrice;
             comparePriceElement.closest('.price-item--regular').style.display = '';
           } else {
             comparePriceElement.closest('.price-item--regular').style.display = 'none';
           }
         }
       } catch (error) {
         console.error('Error updating sticky button prices:', error);
       }
     }

     handleMainFormVariantChange(event) {
       if (this.variantSelect && event.detail.variant) {
         this.variantSelect.value = event.detail.variant.id;
         
         // Update sticky button prices when main form changes
         const variantId = event.detail.variant.id;
         this.handleVariantChange({ target: { value: variantId } });
       }
     }

     async handleStickyAddToCart(event) {
       event.preventDefault();
       event.stopPropagation();
       
       if (!this.productForm) return;
       
       // Show loading state
       this.addToCartButton.classList.add('loading');
       
       try {
         // Trigger the main form submission
         const mainForm = this.productForm.querySelector('form[data-type="add-to-cart-form"]');
         if (mainForm) {
           const submitButton = mainForm.querySelector('[type="submit"]');
           if (submitButton) {
             submitButton.click();
             
             // Wait for cart update event or timeout after 2 seconds
             await Promise.race([
               new Promise(resolve => {
                 window.addEventListener('cart:refresh', resolve, { once: true });
               }),
               new Promise(resolve => setTimeout(resolve, 2000))
             ]);
           }
         }
         
         // Show success state
         this.addToCartButton.classList.remove('loading');
         this.addToCartButton.classList.add('added');
         
         // Reset button state after 2 seconds
         setTimeout(() => {
           this.addToCartButton.classList.remove('added');
         }, 2000);
       } catch (error) {
         console.error('Error adding to cart:', error);
         this.addToCartButton.classList.remove('loading');
       }
     }
  }

  if (!customElements.get('sticky-add-to-cart')) {
    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    // Process **bold** formatting only in text blocks that contain metafield class
    let metafieldTextBlocks;
    
    // Try modern :has() selector first, fallback to manual check
    try {
      metafieldTextBlocks = document.querySelectorAll('.text-block:has(.metafield-single_line_text_field)');
    } catch (e) {
      // Fallback for browsers that don't support :has()
      const allTextBlocks = document.querySelectorAll('.text-block');
      metafieldTextBlocks = Array.from(allTextBlocks).filter(block => 
        block.querySelector('.metafield-single_line_text_field')
      );
    }
    
    metafieldTextBlocks.forEach(block => {
      const textContent = block.innerHTML;
      let formattedContent = textContent;
      
      // Remove HTML paragraph tags for metafield content
      formattedContent = formattedContent.replace(/<p>/g, '').replace(/<\/p>/g, '');
      formattedContent = formattedContent.replace(/&lt;p&gt;/g, '').replace(/&lt;\/p&gt;/g, '');
      
      // Replace **text** with <span class="text-bold-format">text</span>
      formattedContent = formattedContent.replace(/\*\*(.*?)\*\*/g, '<span class="text-bold-format">$1</span>');
      
      if (formattedContent !== textContent) {
        block.innerHTML = formattedContent;
      }
    });

    const readMoreContainers = document.querySelectorAll('.read-more-container');

    readMoreContainers.forEach(container => {
      const content = container.querySelector('.read-more-content');
      const toggle = container.querySelector('.read-more-toggle');

      if (!content || !toggle) return;

      // Add loading state immediately to prevent flicker
      content.classList.add('loading');

      // Get the text element inside the content
      const textElement = content.querySelector('.text-block');
      if (!textElement) return;

      // Use requestAnimationFrame to ensure DOM is fully rendered
      requestAnimationFrame(() => {
        initializeReadMore(container, content, toggle, textElement);
      });
    });

    function initializeReadMore(container, content, toggle, textElement) {
      // Get computed styles
      const computedStyle = getComputedStyle(textElement);
      const fontSize = parseFloat(computedStyle.fontSize);
      const lineHeight = parseFloat(computedStyle.lineHeight);
      const actualLineHeight = isNaN(lineHeight) ? fontSize * 1.5 : lineHeight;

      // Get lines to show from CSS variable
      const linesToShow = parseInt(content.style.getPropertyValue('--lines-to-show')) || 3;

      // Calculate max height based on actual line height
      const maxHeight = actualLineHeight * linesToShow;
      const actualHeight = textElement.scrollHeight;

      // Add some tolerance for rounding errors
      const tolerance = 2;

      if (actualHeight <= (maxHeight + tolerance)) {
        // Content doesn't need truncation, hide the button and remove loading state
        toggle.style.display = 'none';
        content.classList.remove('loading');
        content.style.maxHeight = 'none'; // Allow natural height
        return;
      }

      // Set collapsed height immediately
      content.style.setProperty('--max-height-collapsed', maxHeight + 'px');

      // Temporarily expand to get the full height for smooth animation
      // Use a more reliable method to get full height
      const originalHeight = content.style.maxHeight;
      content.style.maxHeight = 'none';
      const fullHeight = textElement.scrollHeight;
      content.style.maxHeight = originalHeight;

      // Set expanded height
      content.style.setProperty('--max-height-expanded', fullHeight + 'px');

      // Remove loading state and add collapsed class
      content.classList.remove('loading');
      content.classList.add('collapsed');
      toggle.setAttribute('aria-expanded', 'false');

      // Add click handler with smooth transitions
      toggle.addEventListener('click', function() {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        const readMoreText = toggle.querySelector('.read-more-text');
        const readLessText = toggle.querySelector('.read-less-text');

        // Prevent multiple clicks during animation
        if (content.classList.contains('animating')) return;
        content.classList.add('animating');

        if (isExpanded) {
          // Collapse the content
          content.classList.remove('expanded');
          content.classList.add('collapsed');
          toggle.setAttribute('aria-expanded', 'false');

          // Update button text
          if (readMoreText) readMoreText.style.display = 'inline';
          if (readLessText) readLessText.style.display = 'none';
        } else {
          // Expand the content
          content.classList.remove('collapsed');
          content.classList.add('expanded');
          toggle.setAttribute('aria-expanded', 'true');

          // Update button text
          if (readMoreText) readMoreText.style.display = 'none';
          if (readLessText) readLessText.style.display = 'inline';
        }

        // Remove animating class after transition completes
        setTimeout(() => {
          content.classList.remove('animating');
        }, 400); // Match CSS transition duration
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
